import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatFc, formatFcAtRate, isForeignCurrency } from '../../utils/fcDocuments';

interface Props {
  currency?: string | null;
  rate?: number | null;
  /** Foreign total/amount of the document. */
  foreign?: number | null;
  /** Its BDT figure (at the document rate). */
  bdt: number;
  /** Optional open foreign balance. */
  foreignOutstanding?: number | null;
  /** Realised FX (gain positive), for a receipt/payment. */
  fxDifference?: number | null;
}

/** B4-C: "USD 12,500.00 at 121.50 = BDT 1,518,750.00" beside a foreign-currency document; nothing for BDT. */
const FcAmountLine: React.FC<Props> = ({ currency, rate, foreign, bdt, foreignOutstanding, fxDifference }) => {
  if (!isForeignCurrency(currency) || foreign == null || rate == null) return null;
  return (
    <Box data-testid="fc-amount-line">
      <Typography variant="body2" color="text.secondary">Foreign currency</Typography>
      <Typography>{formatFcAtRate(currency!, foreign, rate, bdt)}</Typography>
      {foreignOutstanding != null && (
        <Typography variant="body2">Open: {formatFc(currency!, foreignOutstanding)}</Typography>
      )}
      {fxDifference != null && fxDifference !== 0 && (
        <Typography variant="body2" color={fxDifference > 0 ? 'success.main' : 'error.main'}>
          Realised FX {fxDifference > 0 ? 'gain' : 'loss'}: BDT {Math.abs(fxDifference).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </Typography>
      )}
    </Box>
  );
};

export default FcAmountLine;
